import Styles from "./BuySell.module.css";
import React, { useEffect, useState, useCallback } from "react";
import {
  Accordion,
  AccordionDetails,
  AccordionSummary,
} from "../../../commons/Accordion";
import {
  getArchive,
  getConnectionHistory,
} from "../../../Services/BuySell/Listing";
import { useDispatch, useSelector } from "react-redux";
import ExpandMoreIcon from "@mui/icons-material/ExpandMore";
import { formatDate, formatSlotTime } from "../../../helpers/dateFormat";
import {
  fetchLedgerBids,
  fetchMainScreenActiveConnection,
} from "../../../Redux/Slices/CapacitySlice";
import { LeftSideBtns } from "../../Bilateral/LedgerViewContent/ledgerUploadDocs";
import { openBilateralChat } from "../../Modals/Banking/CreateEdit/helpers";
import { useLocation } from "react-router-dom";
import { ReactComponent as HistoryIcon } from "../../../assets/images/history.svg";
import { ReactComponent as VectorIcon } from "../../../assets/images/VectorIcon.svg";
import { Modal } from "@mui/material";
import { Close } from "@mui/icons-material";
import Loader from "../../../commons/Loader/Loader";
import ViewInjectionModal from "../../Modals/ConGen/ViewInjectionModal/ViewInjectionModal";

const ConnectionModal = ({ open, onClose, connectionId }) => {
  const dispatch = useDispatch();
  const [loading, setLoading] = useState(false);
  const [connectionData, setConnectionData] = useState([]);
  const [activeId, setActiveId] = useState("");
  const [openInjectionModal, setOpenInjectionModal] = useState(false);

  const role = useSelector(
    (state) => state?.persistedReducer?.user?.activeRole,
  );
  const userDataKey =
    role === "CONSUMER" ? "capacityGenerator" : "capacityConsumer";
  const oppositeuserDataKey =
    role === "CONSUMER" ? "capacityConsumer" : "capacityGenerator";
  const fetchConnectionHistory = useCallback(async () => {
    try {
      if (!open) return;
      setLoading(true);
      const res = await getConnectionHistory(connectionId, role);
      if (res?.data?.code === 200) {
        setConnectionData(res?.data?.data || []);
      }
    } catch (error) {
      console.error("Error fetching connection history:", error);
    } finally {
      setLoading(false);
    }
  }, [connectionId, open, role]);

  useEffect(() => {
    fetchConnectionHistory();
  }, [connectionId, fetchConnectionHistory]);
  return (
    <>
      {" "}
      {openInjectionModal && (
        <ViewInjectionModal
          open={openInjectionModal}
          handleClose={() => {
            setOpenInjectionModal(false);
            setActiveId("");
          }}
          data={
            connectionData?.find((ele) => ele[userDataKey]?.id === activeId)[
              userDataKey
            ]
          }
        />
      )}
      <Modal
        open={open}
        onClose={onClose}
        aria-labelledby="child-modal-title"
        aria-describedby="child-modal-description"
      >
        <div className={`popupModal ${Styles.createEditModalCont}`}>
          <div
            className={`display_flex_row modalHeading  ${Styles.modalHeading}`}
          >
            <div className="headingText">Connection History</div>
            <Close
              style={{ fontSize: "24px", color: "#777777", cursor: "pointer" }}
              onClick={onClose}
            />
          </div>
          <div className={Styles.docContainer}>
            <table
              className={Styles.connectionHistoryTable}
              style={{ width: "100%", tableLayout: "fixed" }}
            >
              <colgroup>
                <col style={{ width: "20%" }} />
                <col style={{ width: "26%" }} />
                <col style={{ width: "13%" }} />
                <col style={{ width: "15%" }} />
                <col style={{ width: "33%" }} />
              </colgroup>
              <thead>
                <tr>
                  <th>Name</th>
                  <th>Requisitions</th>
                  <th>EMD</th>
                  <th>Initial Margin</th>
                  <th>Action</th>
                </tr>
              </thead>
            </table>

            <div className={Styles.docContentScroll}>
              {loading ? (
                <div className={Styles.loadingRow}>
                  <Loader />
                </div>
              ) : Array.isArray(connectionData) && connectionData.length > 0 ? (
                <table
                  className={Styles.connectionHistoryTable}
                  style={{ width: "100%", tableLayout: "fixed" }}
                >
                  <colgroup>
                    <col style={{ width: "20%" }} />
                    <col style={{ width: "26%" }} />
                    <col style={{ width: "13%" }} />
                    <col style={{ width: "15%" }} />
                    <col style={{ width: "33%" }} />
                  </colgroup>
                  <tbody>
                    {connectionData.map((doc) => (
                      <tr key={doc.id}>
                        <td style={{ fontSize: "12px" }}>
                          {doc[userDataKey]?.name || "-"}
                        </td>

                        <td
                          style={{
                            cursor: "pointer",
                            color: "#617499",
                            textDecoration: "underline",
                          }}
                          onClick={() => {
                            setOpenInjectionModal(true);
                            setActiveId(doc[userDataKey].id);
                          }}
                        >
                          View Details
                        </td>

                        <td>{doc[userDataKey]?.emd || "-"} (₹/KWh)</td>

                        <td>{doc[userDataKey]?.initialMargin || "-"}%</td>

                        <td
                          style={{ display: "flex", justifyContent: "center" }}
                        >
                          <div className={Styles.connectionBtns}>
                            <div
                              onClick={() => {
                                let chatId;
                                if (role === "CONSUMER") {
                                  chatId = `${doc[oppositeuserDataKey]?.split("_")?.[0]}_${doc[userDataKey]?.name?.split("_")?.[0]}`;
                                } else {
                                  chatId = `${doc[userDataKey]?.name?.split("_")?.[0]}_${doc[oppositeuserDataKey]?.split("_")?.[0]}`;
                                }
                                openBilateralChat(dispatch, {
                                  header: doc[userDataKey]?.name,
                                  fromUser: doc[oppositeuserDataKey]?.name,
                                  toUser: doc[userDataKey]?.name,
                                  chatId: chatId,
                                  type: "BILATERAL",
                                  hidechat: false,
                                });
                              }}
                              className={Styles.chatBtn}
                            >
                              Chat History
                            </div>
                          </div>
                        </td>
                      </tr>
                    ))}
                  </tbody>
                </table>
              ) : (
                <div className={Styles.connectHistory}>
                  No connection history found.
                </div>
              )}
            </div>
          </div>
        </div>
      </Modal>
    </>
  );
};

const LoaderNoData = ({ loading, dataLength }) => {
  if (loading) {
    return (
      <div className={Styles.loaderContainer}>
        <div className={Styles.loader} role="status" aria-label="loading" />
      </div>
    );
  }
  if (!loading && dataLength === 0) {
    return <div className={Styles.noDataContainer}>No records found</div>;
  }
  return null;
};

const SummaryHeader = () => (
  <div className={Styles.accordionSummaryContainer}>
    <table
      className={Styles.summaryTable}
      style={{ tableLayout: "fixed", width: "100%" }}
    >
      <colgroup>
        <col style={{ width: "5%" }} />
        <col style={{ width: "20%" }} />
        <col style={{ width: "15%" }} />
        <col style={{ width: "15%" }} />
        <col style={{ width: "15%" }} />
        <col style={{ width: "15%" }} />
      </colgroup>
      <thead className={Styles.summaryHeader}>
        <tr>
          <th className={Styles.summaryHeaderCell}>S.No</th>
          <th className={Styles.summaryHeaderCell}>Listing Id</th>
          <th className={Styles.summaryHeaderCell}>Product Type</th>
          <th className={Styles.summaryHeaderCell}>Energy Type</th>
          <th className={Styles.summaryHeaderCell}>Delivery Type</th>
          <th className={Styles.summaryHeaderCell}>Listing Exp. Date</th>
          <th className={Styles.summaryHeaderCell}>Listing Exp. Time</th>
        </tr>
      </thead>
    </table>
  </div>
);

const SummaryHeaderWithdrawn = ({ statusFromQuery }) => (
  <div className={Styles.accordionSummaryContainer}>
    <table
      className={Styles.summaryTable}
      style={{ tableLayout: "fixed", width: "100%" }}
    >
      <colgroup>
        <col style={{ width: "5%" }} />
        <col style={{ width: "20%" }} />
        <col style={{ width: "15%" }} />
        <col style={{ width: "15%" }} />
        <col style={{ width: "15%" }} />
        <col style={{ width: "15%" }} />
        {statusFromQuery === "Withdrawn" ? null : (
          <col style={{ width: "15%" }} />
        )}
      </colgroup>
      <thead className={Styles.summaryHeader}>
        <tr>
          <th className={Styles.summaryHeaderCell}>S.No</th>
          <th className={Styles.summaryHeaderCell}>Listing Id</th>
          <th className={Styles.summaryHeaderCell}>Product Type</th>
          <th className={Styles.summaryHeaderCell}>Energy Type</th>
          <th className={Styles.summaryHeaderCell}>Delivery Type</th>
          <th className={Styles.summaryHeaderCell}>Listing Exp. Date</th>
          <th className={Styles.summaryHeaderCell}>Listing Exp. Time</th>
          {statusFromQuery === "Withdrawn" ? null : (
            <th className={Styles.summaryHeaderCell}>Action</th>
          )}
        </tr>
      </thead>
    </table>
  </div>
);

const SummaryInnerHeader = () => (
  <div
    style={{ marginBottom: "10px" }}
    className={Styles.accordionSummaryContainer}
  >
    <table
      className={Styles.summaryTable}
      style={{ tableLayout: "fixed", width: "100%" }}
    >
      <colgroup>
        <col style={{ width: "5%" }} />
        <col style={{ width: "30%" }} />
        <col style={{ width: "15%" }} />
        <col style={{ width: "15%" }} />
        <col style={{ width: "20%" }} />
        <col style={{ width: "15%" }} />
      </colgroup>
      <thead className={Styles.summaryHeader}>
        <tr>
          <th
            style={{ paddingLeft: "35px" }}
            className={Styles.summaryInnerHeaderCell}
          >
            Counterparty
          </th>
          <th className={Styles.summaryInnerHeaderCell}>Quantity</th>
          <th className={Styles.summaryInnerHeaderCell}>Energy Rate</th>
          <th className={Styles.summaryInnerHeaderCell}>Date Range</th>
          <th className={Styles.summaryInnerHeaderCell}>Time Range</th>
          <th className={Styles.summaryInnerHeaderCell}>Status</th>
        </tr>
      </thead>
    </table>
  </div>
);

const capitalizeFirst = (str) =>
  typeof str === "string" && str.length > 0
    ? str.charAt(0).toUpperCase() + str.slice(1).toLowerCase()
    : "";

const getRateLabel = (conn) => {
  if (!conn) return "";
  if (conn?.energyRateType === "FIXED") return `${conn?.amount}`;
  return `${conn?.energyRateType === "DAM_PLUS" ? "DAM+" : "DAM-"}${
    conn?.amount
  }`;
};

const extractListingId = (name) => {
  if (!name || typeof name !== "string") return null;
  const m = name.match(/^[GC]?(\d+)(?:_|$)/i);
  return m ? m[1] : null;
};

const BilateralConnections = ({
  matches,
  userDataKey,
  parentName,
  dispatch,
  showStatusButtons = true,
  showHeader = false,
}) => {
  const user = useSelector((state) => state.persistedReducer.user?.activeRole);
  if (!Array.isArray(matches) || matches.length === 0) return null;

  return (
    <>
      {showHeader && <SummaryInnerHeader />}
      {matches.map((m, idx) => {
        if (!Object.keys(m || {}).includes("bilateralConnections")) return null;
        const key = m?.id ?? m?.name ?? idx;
        return (
          <div
            style={{
              margin: "7px",
              border: "var(--border-level2)",
              borderRadius: "10px",
            }}
            key={key}
          >
            <div
              style={{ paddingRight: "15px" }}
              className={`display_flex_row ${Styles.accHeaderTable_name}`}
            >
              <div
                style={{ marginLeft: "0.7%" }}
                className={`table_text_align_left ${Styles.nameCompanyDetails}`}
              >
                <div>
                  {m?.[userDataKey]?.consumerName ||
                    m?.[userDataKey]?.generatorName}
                </div>
                <div>{m?.[userDataKey]?.name}</div>
              </div>
              <div className={Styles.chatButtonContainer}>
                <span>{capitalizeFirst(m?.status)}</span>
              </div>
            </div>

            {Array.isArray(m?.bilateralConnections) &&
              m.bilateralConnections
                .filter((conn) => conn.status !== "REJECTED")
                .map((conn, i) => (
                  <table
                    className={Styles.ledgerTableHeading}
                    key={conn?.id ?? i}
                    style={{
                      width: "100%",
                      tableLayout: "fixed",
                      color: "var(--fourth-color-text)",
                      fontSize: "12px",
                    }}
                  >
                    <colgroup>
                      <col style={{ width: "5%" }} />
                      <col style={{ width: "30%" }} />
                      <col style={{ width: "15%" }} />
                      <col style={{ width: "15%" }} />
                      <col style={{ width: "20%" }} />
                      <col style={{ width: "15%" }} />
                    </colgroup>
                    <tbody
                      style={{
                        textAlign: "center",
                        textWrap: "nowrap",
                      }}
                    >
                      <tr style={{ height: "40px" }}>
                        <td
                          style={{
                            textAlign: "left",
                            paddingLeft: "30px",
                            color: "#8C8A96",
                          }}
                        >
                          Connection {i + 1}
                        </td>
                        <td>{conn?.quantity} (MW)</td>
                        <td>{getRateLabel(conn)} (₹/kWh)</td>
                        <td>
                          {formatDate(conn?.dateStartAt)} -{" "}
                          {formatDate(conn?.dateEndAt)}
                        </td>
                        <td>
                          {formatSlotTime(conn?.slotStartAt)} -{" "}
                          {formatSlotTime(conn?.slotEndAt)}
                        </td>
                      </tr>
                    </tbody>
                  </table>
                ))}

            {showStatusButtons && (
              <div
                style={{ paddingRight: "calc(100vw - 97vw)" }}
                className={Styles.statusBtnContainer}
              >
                <LeftSideBtns showEditDocs={false} clickedIndex={idx} />

                <button
                  type="button"
                  className={Styles.chatButton}
                  onClick={() => {
                    let chatId;

                    if (user === "CONSUMER") {
                      chatId = `${parentName?.split("_")?.[0]}_${m?.[userDataKey]?.name?.split("_")?.[0]}`;
                    } else {
                      chatId = `${m?.[userDataKey]?.name?.split("_")?.[0]}_${parentName?.split("_")?.[0]}`;
                    }
                    openBilateralChat(dispatch, {
                      header: m?.[userDataKey]?.name,
                      fromUser: parentName,
                      toUser: m?.[userDataKey]?.name,
                      chatId: chatId,
                      type: "BILATERAL",
                      hidechat: false,
                    });
                  }}
                >
                  View Chat
                </button>
              </div>
            )}
          </div>
        );
      })}
    </>
  );
};

const SummaryRow = ({ ele, index, expanded, onToggle, userDataKey, role }) => {
  const [openConnectionHistory, setOpenConnectionHistory] = useState(false);
  const dispatch = useDispatch();
  const mainScreenActiveConnectionLoading = useSelector(
    (state) => state?.CapacitySlice?.fetchMainScreenActiveConnectionLoading,
  );
  const fetchLedgerBidsLoading = useSelector(
    (state) => state?.CapacitySlice?.fetchLedgerBidsLoading,
  );

  const mainScreenActiveConnectionData = useSelector(
    (state) => state?.CapacitySlice?.mainScreenActiveConnection,
  );

  const matchData = mainScreenActiveConnectionData;

  const showLoader =
    mainScreenActiveConnectionLoading || fetchLedgerBidsLoading;

  if (!ele) return null;
  return (
    <>
      <ConnectionModal
        open={openConnectionHistory}
        onClose={() => setOpenConnectionHistory(false)}
        connectionId={ele?.id}
      />{" "}
      <div
        className={expanded === index ? "" : Styles.detailsMainDrop_inactive}
      >
        <Accordion
          style={{
            backgroundColor: "#f3f5f8",
            marginTop: index === 0 ? "0px" : "3px",
            border:
              expanded === index
                ? "1px solid var(--primary-color-text)"
                : "none",
            borderRadius: "10px",
          }}
          expanded={expanded === index}
          onChange={() => onToggle(index)}
        >
          <AccordionSummary
            style={{
              backgroundColor: "white",
              borderRadius: "8px",
            }}
          >
            <div className={Styles.accordionSummaryContainer}>
              <table
                className={Styles.summaryTable}
                style={{ tableLayout: "fixed", width: "100%" }}
              >
                <colgroup>
                  <col style={{ width: "5%" }} />
                  <col style={{ width: "20%" }} />
                  <col style={{ width: "15%" }} />
                  <col style={{ width: "15%" }} />
                  <col style={{ width: "15%" }} />
                  <col style={{ width: "15%" }} />
                </colgroup>
                <tbody>
                  <tr>
                    <td className={Styles.summaryCell}>
                      <div
                        style={{
                          display: "flex",
                          alignItems: "center",
                          justifyContent: "center",
                          gap: 6,
                        }}
                      >
                        <ExpandMoreIcon
                          style={{ fontSize: "18px" }}
                          className={`${Styles.expandIconLeft} ${
                            expanded === index ? Styles.rotateIcon : ""
                          }`}
                        />
                        {index + 1}
                      </div>
                    </td>
                    <td className={Styles.summaryCell}>{ele?.name}</td>
                    <td className={Styles.summaryCell}>
                      {ele.listingType === "INTRA_DAY"
                        ? "Intraday"
                        : ele.listingType === "NEXT_DAY"
                          ? "Next Day"
                          : ele.listingType === "UPTO_SEVEN_DAYS"
                            ? "Next 7 Days"
                            : ele.listingType === "GREATER_THAN_SEVEN_DAYS"
                              ? "Custom"
                              : // ? "Greater than 7 Days"
                                "-"}{" "}
                    </td>
                    <td className={Styles.summaryCell}>
                      {ele?.energyFuelType}
                    </td>
                    <td className={Styles.summaryCell}>
                      {ele?.isInterstate ? "Interstate" : "Intra-state"}
                    </td>
                    <td className={Styles.summaryCell}>
                      {formatDate(ele?.listingExpDate)}
                    </td>
                    <td className={Styles.summaryCell}>
                      {formatSlotTime(ele?.listingExpTime)}
                    </td>
                  </tr>
                </tbody>
              </table>
            </div>
          </AccordionSummary>

          <AccordionDetails
            style={{
              backgroundColor: "white",
              borderRadius: "8px",
            }}
          >
            {/* details wrapper: show loader inside this container */}
            <div
              style={{
                border: "1px solid var(--secondary-color-text)",
                margin: "0px 10px 10px 10px",
              }}
              className={Styles.accordionDetailsContainerUploadDocs}
            >
              {showLoader && (
                <div className={Styles.loaderContainer}>
                  <div
                    className={Styles.loader}
                    role="status"
                    aria-label="loading connection"
                  />
                </div>
              )}
              {!showLoader &&
                (Array.isArray(matchData) && matchData.length ? (
                  <>
                    <BilateralConnections
                      matches={matchData}
                      userDataKey={userDataKey}
                      parentName={ele?.name}
                      dispatch={dispatch}
                      showHeader={mainScreenActiveConnectionData.length > 0}
                    />

                    <div
                      style={{
                        display: "flex",
                        justifyContent: "center",
                        alignItems: "center",
                        padding: "10px",
                        color: "#6F6D7C",
                        cursor: "pointer",
                      }}
                      onClick={() => setOpenConnectionHistory(true)}
                    >
                      <div className={Styles.connHead}>
                        <span>
                          <HistoryIcon
                            style={{
                              width: 15,
                              height: 15,
                              color: "#6F6D7C",
                            }}
                          />
                        </span>
                        <span
                          style={{
                            color: "#6F6D7C",
                            fontSize: "14px",
                          }}
                        >
                          {" "}
                          Connection History
                        </span>
                        <span>
                          <VectorIcon
                            style={{
                              width: 10,
                              height: 10,
                              color: "#6F6D7C",
                            }}
                          />
                        </span>
                      </div>
                    </div>
                  </>
                ) : (
                  <div className={Styles.noDataContainer}>
                    No matching records
                  </div>
                ))}
            </div>
          </AccordionDetails>
        </Accordion>
      </div>
    </>
  );
};

const SummaryRowWithdrawn = ({
  ele,
  index,
  expanded,
  onToggle,
  userDataKey,
  role,
  statusFromQuery,
}) => {
  const dispatch = useDispatch();
  const [openConnectionHistory, setOpenConnectionHistory] = useState(false);
  const capitalizeFirst = (str) =>
    typeof str === "string" && str.length > 0
      ? str.charAt(0).toUpperCase() + str.slice(1).toLowerCase()
      : "";
  const fetchLedgerBidsLoading = useSelector(
    (state) => state?.CapacitySlice?.fetchLedgerBidsLoading,
  );

  const ledgerBidsData =
    useSelector((state) => state?.CapacitySlice?.ledgerBids)?.filter(
      (bid) => bid?.status === "WITHDRAWN",
    ) || [];

  const mainScreenActiveConnectionData = useSelector(
    (state) => state?.CapacitySlice?.mainScreenActiveConnection,
  );

  const matchData =
    mainScreenActiveConnectionData.length > 0
      ? mainScreenActiveConnectionData
      : ledgerBidsData;

  const bilateralItems = Array.isArray(matchData)
    ? matchData.filter((m) =>
        Object.keys(m || {}).includes("bilateralConnections"),
      )
    : [];
  const fallbackItems = Array.isArray(matchData)
    ? matchData.filter(
        (m) => !Object.keys(m || {}).includes("bilateralConnections"),
      )
    : [];

  const showLoader = fetchLedgerBidsLoading;

  if (!ele) return null;
  return (
    <>
      <ConnectionModal
        open={openConnectionHistory}
        onClose={() => setOpenConnectionHistory(false)}
        connectionId={ele?.id}
      />{" "}
      <div
        className={expanded === index ? "" : Styles.detailsMainDrop_inactive}
      >
        <Accordion
          style={{
            backgroundColor: "#f3f5f8",
            marginTop: index === 0 ? "0px" : "3px",
            border:
              expanded === index
                ? "1px solid var(--primary-color-text)"
                : "none",
            borderRadius: "10px",
          }}
          expanded={expanded === index}
          onChange={() => onToggle(index)}
        >
          <AccordionSummary
            style={{
              backgroundColor: "white",
              borderRadius: "8px",
            }}
          >
            <div className={Styles.accordionSummaryContainer}>
              <table
                className={Styles.summaryTable}
                style={{ tableLayout: "fixed", width: "100%" }}
              >
                <colgroup>
                  <col style={{ width: "5%" }} />
                  <col style={{ width: "20%" }} />
                  <col style={{ width: "15%" }} />
                  <col style={{ width: "15%" }} />
                  <col style={{ width: "15%" }} />
                  <col style={{ width: "15%" }} />
                  {statusFromQuery === "Withdrawn" ? null : (
                    <col style={{ width: "15%" }} />
                  )}{" "}
                </colgroup>
                <tbody>
                  <tr>
                    <td className={Styles.summaryCell}>
                      <div
                        style={{
                          display: "flex",
                          alignItems: "center",
                          justifyContent: "center",
                          gap: 6,
                        }}
                      >
                        <ExpandMoreIcon
                          style={{ fontSize: "18px" }}
                          className={`${Styles.expandIconLeft} ${
                            expanded === index ? Styles.rotateIcon : ""
                          }`}
                        />
                        {index + 1}
                      </div>
                    </td>
                    <td
                      style={{ color: "#525062" }}
                      className={Styles.summaryCell}
                    >
                      {ele?.name}
                    </td>
                    <td className={Styles.summaryCell}>
                      {ele.listingType === "INTRA_DAY"
                        ? "Intraday"
                        : ele.listingType === "NEXT_DAY"
                          ? "Next Day"
                          : ele.listingType === "UPTO_SEVEN_DAYS"
                            ? "Next 7 Days"
                            : ele.listingType === "GREATER_THAN_SEVEN_DAYS"
                              ? "Custom"
                              : // ? "Greater than 7 Days"
                                "-"}{" "}
                    </td>
                    <td className={Styles.summaryCell}>
                      {ele?.energyFuelType}
                    </td>
                    <td className={Styles.summaryCell}>
                      {ele?.isInterstate ? "Interstate" : "Intra-state"}
                    </td>
                    <td
                      style={{ color: "#525062" }}
                      className={Styles.summaryCell}
                    >
                      {formatDate(ele?.listingExpDate)}
                    </td>
                    <td
                      style={{ color: "#525062" }}
                      className={Styles.summaryCell}
                    >
                      {formatSlotTime(ele?.listingExpTime)}
                    </td>
                  </tr>
                </tbody>
              </table>
            </div>
          </AccordionSummary>

          <AccordionDetails
            style={{
              backgroundColor: "white",
              borderRadius: "8px",
            }}
          >
            {/* details wrapper: show loader inside this container */}
            <div
              style={{
                margin: "0px 10px 10px 10px",
                border: expanded === index ? "1px solid #34656D" : "none",
              }}
              className={Styles.accordionDetailsContainerUploadDocs}
            >
              {showLoader && (
                <div className={Styles.loaderContainer}>
                  <div
                    className={Styles.loader}
                    role="status"
                    aria-label="loading connection"
                  />
                </div>
              )}
              {!showLoader &&
                (Array.isArray(matchData) && matchData.length ? (
                  <>
                    <BilateralConnections
                      matches={bilateralItems}
                      userDataKey={userDataKey}
                      parentName={ele?.name}
                      dispatch={dispatch}
                      showStatusButtons
                      showHeader={bilateralItems.length > 0}
                    />
                    {fallbackItems.map((m, idx) => {
                      const key = m?.id ?? m?.name ?? idx;
                      const counterPartyRole =
                        role === "consumer" ? "generator" : "consumer";

                      return (
                        <div
                          style={{
                            margin: "7px",
                          }}
                          key={key}
                        >
                          <table
                            className={Styles.ledgerTableHeading}
                            style={{
                              width: "100%",
                              tableLayout: "fixed",
                              color: "var(--fourth-color-text)",
                              fontSize: "12px",
                              marginBottom: 0,
                            }}
                          >
                            <colgroup>
                              <col style={{ width: "4%" }} />
                              <col style={{ width: "20%" }} />
                              <col style={{ width: "16%" }} />
                              <col style={{ width: "15%" }} />
                              <col style={{ width: "16%" }} />
                              <col style={{ width: "15%" }} />
                              {statusFromQuery === "Withdrawn" ? null : (
                                <col style={{ width: "14%" }} />
                              )}{" "}
                            </colgroup>
                            <tbody>
                              <tr>
                                <td>{idx + 1}</td>
                                <td>{m?.[counterPartyRole]?.name}</td>
                                <td className={Styles.summaryCell}>
                                  {m?.[counterPartyRole]?.listingType ===
                                  "INTRA_DAY"
                                    ? "Intraday"
                                    : m?.[counterPartyRole]?.listingType ===
                                        "NEXT_DAY"
                                      ? "Next Day"
                                      : m?.[counterPartyRole]?.listingType ===
                                          "UPTO_SEVEN_DAYS"
                                        ? "Next 7 Days"
                                        : m?.[counterPartyRole]?.listingType ===
                                            "GREATER_THAN_SEVEN_DAYS"
                                          ? "Custom"
                                          : // ? "Greater than 7 Days"
                                            "-"}{" "}
                                </td>
                                <td className={Styles.summaryCell}>
                                  {m?.[counterPartyRole]?.energyFuelType}
                                </td>
                                <td className={Styles.summaryCell}>
                                  {m?.[counterPartyRole]?.isInterstate
                                    ? "Interstate"
                                    : "Intra-state"}
                                </td>
                                <td>
                                  {formatDate(
                                    m?.[counterPartyRole]?.listingExpDate,
                                  )}
                                </td>
                                <td>
                                  {formatSlotTime(
                                    m?.[counterPartyRole]?.listingExpTime,
                                  )}
                                </td>
                                {/* <td>
                                  <div className={Styles.chatButtonContainer}>
                                    <button
                                      type="button"
                                      className={Styles.chatButton}
                                      onClick={() => {
                                        openBilateralChat(dispatch, {
                                          header: m?.[counterPartyRole]?.name,
                                          fromUser: ele?.name,
                                          toUser: m?.[counterPartyRole]?.name,
                                        });
                                      }}
                                    >
                                      View Chat
                                    </button>
                                  </div>
                                </td> */}
                              </tr>
                            </tbody>
                          </table>
                        </div>
                      );
                    })}

                    <div
                      style={{
                        display: "flex",
                        justifyContent: "center",
                        alignItems: "center",
                        padding: "10px",
                        color: "#6F6D7C",
                        cursor: "pointer",
                      }}
                      onClick={() => setOpenConnectionHistory(true)}
                    >
                      <div className={Styles.connHead}>
                        <span>
                          <HistoryIcon
                            style={{
                              width: 15,
                              height: 15,
                              color: "#6F6D7C",
                            }}
                          />
                        </span>
                        <span
                          style={{
                            color: "#6F6D7C",
                            fontSize: "14px",
                          }}
                        >
                          {" "}
                          Connection History
                        </span>
                        <span>
                          <VectorIcon
                            style={{
                              width: 10,
                              height: 10,
                              color: "#6F6D7C",
                            }}
                          />
                        </span>
                      </div>
                    </div>
                  </>
                ) : (
                  <div className={Styles.noDataContainer}>
                    No matching records
                  </div>
                ))}
            </div>
          </AccordionDetails>
        </Accordion>
      </div>
    </>
  );
};

const BuySellArchive = ({ type, status }) => {
  const dispatch = useDispatch();
  const [data, setData] = useState([]);
  const [loading, setLoading] = useState(true);
  const role = useSelector(
    (state) => state?.persistedReducer?.user?.activeRole,
  )?.toLowerCase();
  const userDataKey =
    role === "consumer" ? "capacityGenerator" : "capacityConsumer";
  const [expanded, setExpanded] = useState(0);
  const location = useLocation();
  const searchParams = new URLSearchParams(location.search);
  const statusFromQuery = searchParams.get("status");

  useEffect(() => {
    setExpanded(0);
  }, [type, status]);

  const handleAccordionChange = useCallback(
    (val) => {
      setExpanded((prev) => (prev === val ? -1 : Number(val)));
    },
    [setExpanded],
  );

  useEffect(() => {
    let mounted = true;
    async function fetchData() {
      try {
        setLoading(true);
        const res = await getArchive({ role, status });
        if (!mounted) return;
        if (res?.data?.code === 200) {
          setData(res?.data?.data?.page || []);
        } else {
          setData([]);
        }
      } catch (error) {
        if (mounted) console.error("Error fetching archive data:", error);
        if (mounted) setData([]);
      } finally {
        if (mounted) setLoading(false);
      }
    }
    fetchData();
    return () => {
      mounted = false;
    };
  }, [type, status, role]);

  useEffect(() => {
    if (!Array.isArray(data) || expanded === -1) return;
    const item = data[expanded];
    const capId = extractListingId(item?.name);
    if (!capId) return;

    dispatch(fetchMainScreenActiveConnection({ capId }));
    dispatch(fetchLedgerBids(capId));
  }, [data, dispatch, expanded]);

  return (
    <>
      <div
        style={{
          height: "calc(100vh - 180px)",
          overflowY: "auto",
          overflowX: "hidden",
        }}
      >
        <LoaderNoData loading={loading} dataLength={data?.length ?? 0} />

        {statusFromQuery === "Closed" ? (
          <>
            {data?.length > 0 && <SummaryHeader />}
            {data?.map((ele, index) => (
              <SummaryRow
                key={ele?.id ?? ele?.name ?? index}
                ele={ele}
                index={index}
                expanded={expanded}
                onToggle={handleAccordionChange}
                userDataKey={userDataKey}
                role={role}
              />
            ))}
          </>
        ) : statusFromQuery === "Withdrawn" ? (
          <>
            {data?.length > 0 && (
              <SummaryHeaderWithdrawn statusFromQuery={statusFromQuery} />
            )}
            {data?.map((ele, index) => (
              <SummaryRowWithdrawn
                key={ele?.id ?? ele?.name ?? index}
                ele={ele}
                index={index}
                expanded={expanded}
                onToggle={handleAccordionChange}
                userDataKey={userDataKey}
                role={role}
                statusFromQuery={statusFromQuery}
              />
            ))}
          </>
        ) : statusFromQuery === "Expired" ? (
          <>
            {data?.length > 0 && (
              <SummaryHeaderWithdrawn statusFromQuery={statusFromQuery} />
            )}
            {data?.map((ele, index) => (
              <SummaryRowWithdrawn
                key={ele?.id ?? ele?.name ?? index}
                ele={ele}
                index={index}
                expanded={expanded}
                onToggle={handleAccordionChange}
                userDataKey={userDataKey}
                role={role}
                statusFromQuery={statusFromQuery}
              />
            ))}
          </>
        ) : null}
      </div>
    </>
  );
};

export default BuySellArchive;
